import { useToolSpecContext } from "providers/ToolSpecProvider/ToolSpecProvider";
import { DataTableStoreState } from "../store/DataTableProvider.types";
import {
  EuiButtonEmpty,
  EuiFlexGroup,
  EuiFlexItem,
  EuiIcon,
  EuiText,
} from "@inscopix/ideas-eui";
import { ButtonToolDocs } from "components/ButtonToolDocs/ButtonToolDocs";

interface DataTableToolInfoProps {
  selectedTable: DataTableStoreState["tables"][number];
}

export const DataTableToolInfo = ({
  selectedTable,
}: DataTableToolInfoProps) => {
  // find tool spec from selected table tool version
  const { availableToolSpecs } = useToolSpecContext();
  const toolSpec =
    selectedTable?.kind === "analysis"
      ? availableToolSpecs.find(
          (toolSpec) =>
            toolSpec.toolVersionId === selectedTable?.toolVersion?.id,
        )
      : undefined;

  if (toolSpec === undefined) {
    return null;
  }

  return (
    <EuiFlexGroup
      data-test-subj="workflow-info"
      responsive={false}
      alignItems="center"
      gutterSize="xs"
    >
      <EuiFlexItem grow={false}>
        <EuiIcon type="indexMapping" color="subdued" />
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
        <EuiText color="subdued" size="s">
          <strong>{toolSpec.toolName}</strong> ({toolSpec.toolVersionVersion})
        </EuiText>
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
        <ButtonToolDocs
          tool={{ key: toolSpec.spec.key }}
          EuiButtonComponent={EuiButtonEmpty}
        />
      </EuiFlexItem>
    </EuiFlexGroup>
  );
};
